import { Wrapper, PromisePointWrapper, IconBackground, Title, Text } from './PromisePoints.styles'
import Icon from '../Icons'
import Container from '../Container'
import Link from 'next/link'

const PromisePoints: React.FC = () => {
  type PromisePoint = {
    title: string
    icon: string
    href: string
  }

  const promisePoints: PromisePoint[] = [
    {
      title: 'Terms and conditions',
      icon: 'calendar',
      href: 'https://cdn.experienceoz.com.au/assets/organisation/15644/termsAndConditions/159075.pdf',
    },
    {
      title: 'Frequently asked questions',
      icon: 'info',
      href: 'https://cdn.experienceoz.com.au/assets/organisation/15644/kioskBanner/159076.pdf',
    },
    {
      title: 'Privacy policy',
      icon: 'membership',
      href: '/en/privacy-policy',
    },
  ]

  return (
    <Container style={{ position: 'relative' }}>
      <Wrapper>
        {promisePoints.map((point, idx) => {
          return (
            <Link key={idx} href={point.href} target="_blank">
              <PromisePointWrapper>
                <IconBackground>
                  {/* @ts-ignore */}
                  <Icon name={point.icon} height={30} width={30} />
                </IconBackground>
                <Title>{point.title}</Title>
              </PromisePointWrapper>
            </Link>
          )
        })}
      </Wrapper>
    </Container>
  )
}

export default PromisePoints
